<template>
    <div>
        <headerNotice routerName="申请列表"></headerNotice>
        <!-- 搜索栏 -->
        <div class="searchBox">
            <el-row :gutter="24">
               
                <!-- 订单状态搜索 -->
                <el-col :span="3" :offset="0">
                    <el-select
                        v-model="serachForm.status"
                        @change="fastOrderStatusSearch"
                        placeholder="请选择状态"
                        @value='serachForm.status'
                    >
                        <el-option label="全部" :value="0"></el-option>
                        <el-option label="待审核" :value="1"></el-option>
                        <el-option label="已审核" :value="2"></el-option>
                        <el-option label="已拒绝" :value="3"></el-option>
                    </el-select>
                </el-col>
                 <el-col :span="5" :offset="0">
                    <el-input placeholder="请输入单号" v-model="serachForm.receiptNo">
                        <el-button slot="append" icon="el-icon-search" @click="serachIt"></el-button>
                    </el-input>
                </el-col>
                  <el-col :span="4" :offset="0">
                    <el-date-picker
                        @change='durationChange'
                        style='width:240px;'
                        v-model="duration"
                        type="daterange"
                        range-separator="至"
                        start-placeholder="开始日期"
                        end-placeholder="结束日期"
                        format="yyyy-MM-dd"
                        value-format="yyyy-MM-dd"
                    ></el-date-picker>
                </el-col>
                <!-- <el-col :span="2" :offset="4">
                    <el-button type="primary">
                        <i class="el-icon-refresh"></i> 导出
                    </el-button>
                </el-col> -->
            </el-row>
        </div>
        <!-- 数据表格 -->
        <div class="dataTable" v-loading="loading">
            <el-table
                size='mini'
                :row-style='{"font-size": "14px"}'
                class="tableBox"
                :data="orderList"
                style="width: 100%"
                :default-sort="{prop: 'date', order: 'descending'}"
                @selection-change="handleSelectionChange"
            >
                <el-table-column type="selection" width="55"></el-table-column>
                <el-table-column align="center" prop="name" label="药店名称">
                </el-table-column>
                <!-- <el-table-column align="center" prop="phone" label="电话号码"></el-table-column> -->
                <el-table-column align="center" prop="unit" label="状态" width="150">
                    <template slot-scope="scope">
                        <span v-if="scope.row.status==1" style="color:#f63b3b;">待审核</span>
                        <span v-if="scope.row.status==2" style="color:#f63b3b;">已审核</span>
                        <span v-if="scope.row.status==3" style="color:#f63b3b;">已拒绝</span>
                    </template>
                </el-table-column>
                <el-table-column align="center" prop="createTime" label="提交时间"  sortable></el-table-column>
                  <el-table-column align="center" prop="receiptNo" label="小票单号"  sortable></el-table-column> 
                <el-table-column align="center" label="操作" width="100">
                    <template slot-scope="scope">
                        <el-button @click="watchOrderDetail(scope.row)" size="small">查看</el-button>
                    </template>
                </el-table-column>
            </el-table>
        
            <!--分页-->
            <el-pagination
                class="pagination"
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page.sync="currentPage"
                :page-sizes="[25, 50, 75, 100]"
                layout="total, sizes, prev, pager, next, jumper"
                :total="totalCount"
            ></el-pagination>
        </div>
        <!-- 批量通用标记dialog框 -->
        <el-dialog :title="commonDialogTitle" :visible.sync="commonRemarkDialog" width="30%">
            <el-form :model="commonDialogForm" class="signUp_Form" label-width="125px">
                <el-row>
                    <el-col class="sale" :span="20">
                        <el-form-item label="备注：" :rules="[{'required':true}]">
                            <el-input
                                type="textarea"
                                maxlength="100"
                                placeholder="请输入备注，备注内容不能超过100个字"
                                :autosize="{minRows: 6 }"
                                clearable
                                v-model="commonDialogForm.remark"
                            ></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <div class="btnBox" style="text-align:center;">
                    <el-button @click="cancelBtn">取消</el-button>
                    <el-button @click="commonDialogConfirm" type="primary">确认</el-button>
                </div>
            </el-form>
        </el-dialog>
    </div>
</template>

<script>
import headerNotice from "../../components/common/headerNotice.vue";
export default {
  data() {
    return {
      baseUrl: this.$store.state.apiUrl,
      loading: true,
      orderStatus: this.$route.query.status ? this.$route.query.status : 0,
      totalCount: 0, //总数据条数
      maxResultCount: 25, //默认一页显示的个数,
      currentPage: 1,
      orderList: [], //商品列表主数据
      searchDialog: false, //高级搜索弹框显示是否
      submitTime: [],
      duration: [],
      printStatus: 0,
      salesmanList: [], //业务员列表
      serachForm: {
        //高级搜索弹框数据
        keyword: "",
        status: null,
        orderCode: null,
        customer: "",
        startTime: "",
        endTime: "",
        title: "",
        orderPerson: "",
        salesman: 0,
        remark: "",
        orderStatus: [],
        payStatus: null,
        agent: null,
        printStatus: 0
      },
      sorteHouseDialog: false, //是否显示库存详情弹框
      currentCheckItemID: 0, //当前准备设置标签的itemID
      choosedItem: [], //已选择的商品列表
      setVerifyDialog: false, //批量审核订单弹框
      auditForm: {
        audit: 0,
        remark: ""
      }, //审核表单
      commonDialogTitle: "",
      commonRemarkDialog: false, //标记公共dialog框
      commonDialogForm: {
        remark: ""
      },
      currentUri: "" //批量操作api
    };
  },
  components: {
    headerNotice
  },
  mounted() {
    this.getDatas({
      MaxResultCount: this.maxResultCount,
      Status: this.orderStatus,
      orderStatus: []
    });
    this.getSalesmanList();
  },
  beforeRouteEnter(to, from, next) {
    if (from.path == "/home") {
      sessionStorage.setItem("reload", true);
    } else {
      sessionStorage.setItem("reload", false);
    }
    next();
  },
  beforeRouteLeave(to, from, next) {
    let reload = sessionStorage.getItem("reload");
    if (reload) {
      sessionStorage.setItem("routerStatus", from.query.status);
    } else {
      sessionStorage.removeItem("routerStatus");
    }
    next();
  },
  activated() {
    let reload = sessionStorage.getItem("reload");
    let status = sessionStorage.getItem("routerStatus");

    if (reload && this.$route.query.status) {
      let params = {
        keyword: "",
        status: Number(this.$route.query.status) || 0,
        orderCode: null,
        customer: "",
        startTime: "",
        endTime: "",
        title: "",
        orderPerson: "",
        salesman: 0,
        remark: "",
        orderStatus: [],
        payStatus: null,
        agent: null,
        printStatus: 0,
        MaxResultCount: this.maxResultCount
      };
      this.serachForm = params;
      this.getDatas(params);
      this.currentPage = 1;
    }
  },
  methods: {
    // 根据时间搜索
    durationChange(val) {
      if (!val) {
        val = [];
      }
      this.serachForm.startTime = val[0];
      this.serachForm.endTime = val[1];
      this.getDatas({
        MaxResultCount: this.maxResultCount,
         Status: this.serachForm.status?this.serachForm.status:0,
        receiptNo: this.serachForm.receiptNo,
        startTime: val[0],
        endTime: val[1]
      });
    },
    //获取列表数据
    getDatas(params) {
      let self = this;
      self.loading = true;
      $http.POST({
        url:
          this.$store.state.apiUrl +
          "/api/services/app/AdminApply/PostApply",
        data: params,
        success(res) {
          self.orderList = res.items;
          self.totalCount = res.totalCount;
          self.loading = false;
        },
        fail(res) {
          self.loading = false;
        }
      });
    },
    //名字 编号等搜索
    serachIt() {
      this.getDatas({
        MaxResultCount: this.maxResultCount,
        Status: this.serachForm.status?this.serachForm.status:0,
        receiptNo: this.serachForm.receiptNo,
         startTime: "",
        endTime: ""
      });
      this.currentPage = 1;
    },
    //高级搜索dialog弹框
    advancedSearch() {
      this.searchDialog = true;
    },
    //清空高级搜索数据
    clearSerachForm() {
      this.submitTime = [];
      this.serachForm = {
        //高级搜索弹框数据
        keyword: "",
        status: null,
        orderCode: null,
        customer: "",
        startTime: "",
        endTime: "",
        title: "",
        orderPerson: "",
        salesman: 0,
        remark: "",
        orderStatus: [],
        payStatus: null,
        agent: null,
        printStatus: 0
      };
    },
    //高级搜索确认
    searchDialogConfirm() {
      let params = this.serachForm;
      if (this.submitTime.length) {
        let startTime = this.submitTime[0];
        let endTime = this.submitTime[1];
        params.startTime = startTime;
        params.endTime = endTime;
      }
      params.MaxResultCount = this.maxResultCount;
      this.searchDialog = false;
      this.getDatas(params);
      this.currentPage = 1;
    },
    //查看订单
    watchOrderDetail(row) {
      this.$router.push({
        path: "/applydetail",
        query: {
          applyID: row.applyID
        }
      });
    },
    //勾选单个表格
    handleSelectionChange(val) {
      this.choosedItem = val;
    },
    //批量审核订单点击
    batchAuditOrder() {
      let self = this;
      if (this.choosedItem.length) {
        for (let index = 0; index < self.choosedItem.length; index++) {
          debugger;
          const element = self.choosedItem[index];
          if (element.orderStatus!=3) {
            this.$message.error("不是待审核订单无法审核");
                return;
          }
        }

        this.$confirm("确认批量审核已勾选的订单吗？", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        })
          .then(() => {
            let orderIDArr = [];
            self.choosedItem.forEach((ele, index) => {
              orderIDArr.push(ele.orderID);
            });
            $http.POST({
              url:
                this.$store.state.apiUrl +
                "/api/services/app/AdminOrder/AuditOrderVol",
              data: {
                orderID: orderIDArr
              },
              success(res) {
                self.$message({
                  type: "success",
                  message: `已审核！`
                });
                self.clearSerachForm();
                self.getDatas({
                  MaxResultCount: self.maxResultCount,
                  Status: 0,
                  orderStatus: []
                });
                self.currentPage = 1;
                self.$forceUpdate();
              },
              fail(res) {}
            });
          })
          .catch(() => {});
      } else {
        this.$message.error("请先勾选要审核的订单！");
        return;
      }
    },
    //取消按钮
    cancelBtn() {
      this.setVerifyDialog = false;
      this.commonRemarkDialog = false;
    },
    //批量审核订单确定
    confirmAudit() {
      let self = this;
      if (!this.auditForm.audit) {
        this.$message.error("请将滑块移到审核状态！");
        return;
      }
      if (!this.auditForm.remark) {
        this.$message.error("请填写备注");
        return;
      }
      this.setVerifyDialog = false;
      let orderIDArr = [];
      self.choosedItem.forEach((ele, index) => {
        orderIDArr.push(ele.orderID);
      });
      $http.POST({
        url:
          this.$store.state.apiUrl +
          "/api/services/app/AdminOrder/AuditOrderVol",
        data: {
          orderID: orderIDArr,
          audit: this.auditForm.audit,
          remark: this.auditForm.remark
        },
        success(res) {
          self.$message({
            type: "success",
            message: `已审核！`
          });
          self.clearSerachForm();
          self.getDatas({
            MaxResultCount: self.maxResultCount,
            Status: 0,
            orderStatus: []
          });
          self.currentPage = 1;
          self.$forceUpdate();
        },
        fail(res) {}
      });
    },
    //批量标记异常
    markupException() {
      let self = this;
      if (this.choosedItem.length) {
        this.$confirm("确认批量标记异常已勾选的订单吗？", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        })
          .then(() => {
            let orderIDArr = [];
            self.choosedItem.forEach((ele, index) => {
              orderIDArr.push(ele.orderID);
            });
            $http.POST({
              url:
                this.$store.state.apiUrl +
                "/api/services/app/AdminOrder/AuditFailOrderVol",
              data: {
                orderID: orderIDArr
              },
              success(res) {
                self.$message({
                  type: "success",
                  message: `已标记！`
                });
                self.clearSerachForm();
                self.getDatas({
                  MaxResultCount: self.maxResultCount,
                  Status: 0,
                  orderStatus: []
                });
                self.currentPage = 1;
                self.$forceUpdate();
              },
              fail(res) {}
            });
          })
          .catch(() => {});
      } else {
        this.$message.error("请先勾选要标记的订单！");
        return;
      }
    },
    //批量转正常
    returnNormal() {
      if (this.choosedItem.length) {
        this.commonDialogTitle = "批量转正常";
        this.currentUri = "ReAuditOrderVol";
        this.commonRemarkDialog = true;
      } else {
        this.$message.error("请先勾选要标记的订单！");
        return;
      }
    },
    //批量关闭订单
    closeOrder() {
      if (this.choosedItem.length) {
        this.commonDialogTitle = "批量关闭订单";
        this.currentUri = "CloseOrderVol";
        this.commonRemarkDialog = true;
      } else {
        this.$message.error("请先勾选要标记的订单！");
        return;
      }
    },
    //批量填写备注dialog框
    commonDialogConfirm() {
      let self = this;
      if (!this.commonDialogForm.remark) {
        this.$message.error("请填写备注");
        return;
      }
      this.commonRemarkDialog = false;
      let orderIDArr = [];
      self.choosedItem.forEach((ele, index) => {
        orderIDArr.push(ele.orderID);
      });
      let url =
        this.$store.state.apiUrl +
        "/api/services/app/AdminOrder/" +
        this.currentUri;
      $http.POST({
        url: url,
        data: {
          orderID: orderIDArr,
          remark: this.commonDialogForm.remark
        },
        success(res) {
          self.$message({
            type: "success",
            message: `操作成功！`
          });
          self.clearSerachForm();
          self.getDatas({
            MaxResultCount: self.maxResultCount,
            Status: 0,
            orderStatus: []
          });
          self.currentPage = 1;
          self.$forceUpdate();
        },
        fail(res) {}
      });
    },
    //一页显示多少个
    handleSizeChange(val) {
      this.maxResultCount = val;
      let params = {
        MaxResultCount: val,
        Status: this.orderStatus,
        orderStatus: []
      };
      this.getDatas(params);
    },
    //跳转到指定页
    handleCurrentChange(val) {
      this.loading = true;
      let skipCount = (val - 1) * this.maxResultCount;
      let params = this.serachForm;
      if (this.submitTime.length) {
        let startTime = this.submitTime[0];
        let endTime = this.submitTime[1];
        params.startTime = startTime;
        params.endTime = endTime;
      }
      params.MaxResultCount = this.maxResultCount;
      params.SkipCount = skipCount;
      this.getDatas(params);
    },
    //ERP同步
    ERPSync() {
      let self = this;
      let orderIDArr = [];
      self.choosedItem.forEach((ele, index) => {
        orderIDArr.push(ele.orderID);
      });
      $http.POST({
        url:
          this.$store.state.apiUrl +
          "/api/services/app/AdminErp/SyncOrderToErp",
        data: orderIDArr,
        success(res) {
          let result = res.data;

          if (result != null && result.length > 0) {
            result.forEach(function(sorder) {
              if (sorder.syncStatus != 2) {
                self.orderList.forEach(function(o) {
                  if (o.orderCode === sorder.orderCode) {
                    o.isSyncToErp = 1;
                  }
                });
              }
            });

            for (let i = 0; i < result.length; i++) {
              const item = result[i];
              if (item.syncStatus == 2) {
                self.$message.error(item.msg);
                return;
              }
            }
          }
          self.$message({
            type: "success",
            message: `操作成功！`
          });
        },
        fail(res) {}
      });
    }
  }
};
</script>

<style lang='scss' scoped>
// 搜索栏
.searchBox {
  padding: 20px;
}
// 数据表格
.dataTable {
  padding-bottom: 0;
  margin: 20px;
  .tableBox {
    border: 1px solid #c5c5c5;
  }
  .orderCode {
    margin-left: 10px;
    cursor: pointer;
    &:hover {
      color: #409eff;
    }
  }
  .goodBaseInfo {
    display: flex;
    align-items: center;
    .txtInfo {
      flex: 1;
      display: flex;
      flex-direction: column;
      justify-content: flex-start;
      text-align: left;
      .title {
        font-size: 12px;
        color: #333;
      }
      .itemCode {
        font-size: 10px;
        color: #999;
      }
      .tags {
        display: flex;
        align-items: center;
        span {
          height: 18px;
          line-height: 18px;
          font-style: normal;
          font-size: 10px;
          padding: 0px 8px;
          color: #fff;
          background: #999;
          border-radius: 4px;
          margin-right: 4px;
        }
        /deep/ .el-popover__reference {
          cursor: pointer;
          margin: 0;
          padding: 0;
        }
      }
    }
    img {
      width: 100px;
      height: 100px;
      margin-right: 10px;
    }
  }
  .notice {
    display: inline-block;
    margin-right: 20px;
    i {
      font-style: normal;
      color: #f63b3b;
    }
  }
}
//高级搜索Dialog框
.searchDialog {
  .sale {
    display: flex;
    align-items: center;
    span {
      display: block;
      width: 125px;
      text-align: right;
      box-sizing: border-box;
      padding-right: 12px;
    }
    input {
      -webkit-appearance: none;
      background-color: #fff;
      background-image: none;
      border-radius: 4px;
      border: 1px solid #dcdfe6;
      -webkit-box-sizing: border-box;
      box-sizing: border-box;
      color: #606266;
      display: inline-block;
      font-size: inherit;
      height: 40px;
      line-height: 40px;
      outline: 0;
      padding: 0 15px;
      -webkit-transition: border-color 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);
      transition: border-color 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);
      width: 100px;
      height: 32px;
      outline: #409eff;
      appearance: normal;
    }
  }
  .searchDialogBtn {
    text-align: center;
  }
}
//批量审核dialog框
.auditDialog {
  .btnBox {
    text-align: center;
  }
}
</style>
<style lang="scss">
.goodsListCheckBox {
  display: flex;
  flex-direction: column;
  label {
    margin-left: 0 !important;
  }
}
</style>
